import InfoIcon from 'components/ReusableComponents/Icons/Info'
import moment from 'moment'

import { formatPrice } from '../../../utils/common'
import styles from './InvoiceTable.module.scss'

const MessagesTable = ({
  promotionTextsCost,
  promotionTextsCount,
  totalAfterPromotion,
  items
}) => {
  return (
    <div>
      <div className={styles.table}>
        <TitleRow />
        <div className={styles.dataRowWrapper}>
          {items.map(item => (
            <DataRow key={item.id} {...item} />
          ))}
          <DiscountRow
            promotionTextsCount={promotionTextsCount}
            promotionTextsCost={promotionTextsCost}
          />
          <TotalRow totalBookingValueToCharge={totalAfterPromotion} />
        </div>
      </div>
    </div>
  )
}

const TitleRow = () => (
  <div className={styles.titleRow}>
    <div className={styles.campaignNameRow}>Campaign</div>
    <div className={styles.textsSentRow}>Texts sent</div>
    <div className={styles.commisionRow}>Cost</div>
  </div>
)

const TotalRow = ({ totalBookingValueToCharge }) => (
  <div className={styles.totalRow}>
    <div className={styles.totalRowTitle}>Total messaging fees</div>
    <div className={styles.totalRowValue}>{formatPrice(totalBookingValueToCharge)}</div>
  </div>
)

const DiscountRow = ({ promotionTextsCount, promotionTextsCost }) => {
  if (!promotionTextsCount > 0) {
    return null
  }

  return (
    <div className={styles.dataRowContainer}>
      <div className={styles.dataRow}>
        <div
          className={styles.campaignNameRow}
        >{`Promotion - ${promotionTextsCount} free texts`}</div>
        <div className={styles.textsSentRow}>-{promotionTextsCount}</div>
        <div className={styles.commisionRow}>-{formatPrice(promotionTextsCost)}</div>
      </div>
    </div>
  )
}

const DataRow = ({
  name,
  startedOn,
  type,
  textsSent,
  cost,
  startedBy,
  screenShotUrl
}) => {
  return (
    <div className={styles.dataRowContainer}>
      <div className={styles.dataRow}>
        <div className={styles.campaignNameRow}>
          {type} - {name}
        </div>
        <div className={styles.textsSentRow}>{textsSent}</div>
        <div className={styles.commisionRow}>
          {formatPrice(cost)}{' '}
          {screenShotUrl && (
            <>
              <InfoIcon fill="#A8ADB2" className={styles.tooltipInfoIcon} />
              <div className={styles.tooltip}>
                <div className={styles.tooltipInner}>
                  <p className={styles.tooltipTitle}>Original estimation screenshot</p>
                  <p className={styles.tooltipDescription}>
                    Approved by {startedBy} on {moment(startedOn).format('MMM D, YYYY')}
                  </p>
                </div>
                <img className={styles.screenshot} src={screenShotUrl} alt="Screenshot" />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default MessagesTable
